import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Dialog,
  IconButton,
  Box,
  useTheme,
  CircularProgress,
  Typography,
  Stack,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import PayslipPDF from "./PayslipPDF";

const DownloadPayslipModal = ({ isOpen, onClose, transaction }) => {
  const theme = useTheme();

  if (!transaction) return null;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          overflow: "hidden",
          maxWidth: "900px",
          margin: "16px",
          background:
            theme.palette.mode === "dark"
              ? "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)"
              : "#ffffff",
          boxShadow: theme.shadows[24],
          position: "relative",
          maxHeight: "90vh",
        },
      }}
    >
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ type: "spring", damping: 25, stiffness: 200 }}
          >
            {/* Close Button */}
            <IconButton
              onClick={onClose}
              sx={{
                position: "absolute",
                top: 16,
                right: 16,
                zIndex: 10,
                width: 36,
                height: 36,
                borderRadius: "10px",
                backgroundColor: "rgba(0,0,0,0.05)",
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.1)",
                },
              }}
            >
              <CloseIcon sx={{ fontSize: 20 }} />
            </IconButton>

            {/* Payslip Content */}
            <Box
              sx={{
                maxHeight: "calc(90vh - 40px)",
                overflowY: "auto",
                p: 2,
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-track": {
                  background:
                    theme.palette.mode === "dark" ? "#1e293b" : "#f1f5f9",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#f59e0b",
                  borderRadius: "10px",
                },
              }}
            >
              <PayslipPDF data={transaction} onClose={onClose} />
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </Dialog>
  );
};

export default DownloadPayslipModal;
